import { useEffect, useState } from "react";
import { splitReason } from "../voice";
import { VoiceSetupPanel } from "../VoiceSetup";
import { Sheet, copyText, useApp, useConnection, useHubSummaries } from "../ui";
import { Chevron, Tile, YouIcon } from "./YouParts";

/** Settings: is speaking a message ready on this person's computer, and if not, the one command that fixes it. */
export function VoiceSetting() {
  const { hub, toast } = useApp();
  const summaries = useHubSummaries(hub);
  const first = summaries.find((s) => s.state === "ready") ?? summaries[0];
  const { conn, snap, computer } = useConnection(first?.computer.id ?? "");
  const [open, setOpen] = useState(false);
  const ready = snap.state === "ready";
  useEffect(() => {
    if (ready && snap.voice == null) conn?.refreshVoice();
  }, [ready, snap.voice, conn]);
  if (!first) return null;

  const v = snap.voice;
  const split = v && !v.ready && v.reason ? splitReason(v.reason) : null;
  const sub = !ready ? "Connect to your computer to check." : v == null ? "Checking…" : v.ready ? `Ready. Your words are turned into text on ${computer?.label ?? "your computer"}.` : (split?.lead ?? "Not set up on your computer yet.");

  return (
    <section aria-labelledby="you-voice">
      <div className="group-label" id="you-voice">Voice</div>
      <div className="card you-list">
        <button className="you-row" onClick={() => setOpen(true)} data-testid="voice-setting">
          <Tile>{YouIcon.mic}</Tile>
          <span className="you-row-main">
            <strong>Voice input</strong>
            <span>{sub}</span>
          </span>
          <Chevron />
        </button>
      </div>
      {open && (
        <Sheet onClose={() => setOpen(false)}>
          <div className="head">
            <span className="t">Voice input</span>
            <button className="text-btn plain" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
          <div className="sheet-body">
            <VoiceSetupPanel computerId={first.computer.id} />
          </div>
        </Sheet>
      )}
    </section>
  );
}
